import { Tables } from "@/lib/supabase/supabase_types_override";
import { cn } from "@/lib/utils";
import { useUserStore } from "@/lib/zustand/useStore";
import { cva, VariantProps } from "class-variance-authority";
import React from "react";



const userAvatarVariants = cva(
    "grid place-items-center font-black bg-white rounded-[8px] sm:rounded-[16px] text-primary sm:text-xl",
    {
        variants: {
            variant: {
                default: "bg-lighter-gray",
                reverse: "bg-primary text-white",
            },
            size: {
                default: "w-10 h-10 sm:w-12 sm:h-12",
                sm: "w-8 h-8 sm:w-10 sm:h-10 text-sm sm:text-base",
            },
        },
        defaultVariants: {
            variant: "default",
            size: "default",
        },
    }
)

export interface UserAvatarProps<T extends Tables<'user'> = Tables<'user'>>
    extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof userAvatarVariants> {
    user?: T
}

const UserAvatar = React.forwardRef<HTMLDivElement, UserAvatarProps>(
    ({ className, variant, size, user, ...props }, ref) => {

        const userStore = useUserStore();
        if (!user) {
            user = userStore
        }

        return (
            <div
                className={cn(userAvatarVariants({ variant, size, className }))}
                {...props}
                ref={ref}
            >
                {(user!.first_name?.[0] || "") + "" + (user!.last_name?.[0] || "")}
            </div>
        )
    }
)
UserAvatar.displayName = "UserAvatar"


export { UserAvatar, userAvatarVariants };